module.exports = "<div [ngStyle]=\"{'min-height.px': screenSize}\" class=\"app-section\">\n  <ng-content></ng-content>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /Users/davcocom/Documents/Documents - David’s MacBook Pro/resume/resume-onepage/src/app/section/section.component.html
// module id = ../../../../../src/app/section/section.component.html
// module chunks = main